export enum PermissionEnum {
  CriterionRead = "1",
  CriterionCreate = "2",
  CriterionUpdate = "3",
  CriterionDelete = "4",
  LocationProgramDataRead = "5",
  LocationProgramDataCreate = "6",
  LocationProgramDataUpdate = "7",
  LocationProgramDataDelete = "8",
  RequestRead = "9",
  RequestCreate = "10",
  RequestEvaluate = "11",
  RequestUnlock = "12",
  RequestEdit = "13",
  RequestDelete = "14",
  EnrollmentListRead = "15",
  RequestCommentCreate = "16",
  PhysicalExaminationRead = "17",
  PhysicalExaminationUpdate = "18",
  BenefitRead = "19",
  BenefitCreate = "20",
  BenefitDelete = "21",
  ImportanDateRead = "22",
  ImportanDateUpdate = "23",
  BeneficiaryListRead = "24",
  PhysicalExaminationDocumentUpload = "25",
  RequestCancelEvaluation = "26",
  EnrollmentListUpdate = "27",
  InitialConversationEnabledUpdate = "28"
}
